import { ColouredMarkers } from '@statsbomb/kitbag-datavis';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

export const EventMapShotMarkerLegend = ({ forArrows = false }: { forArrows?: boolean }) => {
  const { t } = useTranslation('visualisation');
  const { dataObjects, base } = useTheme().colours.visualisations;

  return (
    <>
      {!forArrows && (
        <ColouredMarkers
          title={t('shotType.title')}
          markers={[
            {
              label: t('shotType.openPlay'),
              shape: 'HEXAGON',
              colour: dataObjects.neutral.main,
              fill: base.background,
            },
            { label: t('shotType.setPiece'), shape: 'SQUARE', colour: dataObjects.neutral.main, fill: base.background },
            {
              label: t('shotType.throughBall'),
              shape: 'TRIANGLE',
              colour: dataObjects.neutral.main,
              fill: base.background,
            },
            { label: t('shotType.takeOn'), shape: 'DIAMOND', colour: dataObjects.neutral.main, fill: base.background },
            { label: t('shotType.header'), shape: 'CIRCLE', colour: dataObjects.neutral.main, fill: base.background },
          ]}
        />
      )}
      <ColouredMarkers
        title={t('shotOutcome.heading')}
        markers={
          forArrows
            ? [{ label: t('shotOutcome.blocked'), shape: 'CIRCLE', colour: dataObjects.neutral.main }]
            : [
                {
                  label: t('shotOutcome.goal'),
                  shape: 'HEXAGON',
                  colour: dataObjects.inverse,
                  fill: base.background,
                  doubleBorder: true,
                  strokeWidth: 1,
                },
                { label: t('shotOutcome.saved'), shape: 'HEXAGON', colour: dataObjects.inverse, fill: base.background },
                {
                  label: t('shotOutcome.offTarget'),
                  shape: 'HEXAGON',
                  colour: dataObjects.inverse,
                  fill: base.background,
                  strokeWidth: 1,
                },
                { label: t('shotOutcome.blocked'), shape: 'HEXAGON', colour: dataObjects.neutral.main },
              ]
        }
      />
    </>
  );
};
